export default __webpack_public_path__ + "static/jackie-profile-941d7c561d0a25b3cacc44e4673b7f3f.png";